<template>
  <div id="dash-footer">
    <footer class="main-footer">
      <div class="pull-right hidden-xs">
        <b>ESS-ONLINE Version</b>{{ version }}
      </div>
      <strong>
        Copyright &copy; <img class="footer-logo" src="~assets/img/pps_logo.png"> 
        <a href="http://peopleplus.co.th" target="_blank" class="text-skin">People Plus Software Co.,Ltd.</a>
      </strong> Bangkok Thailand (1988)
    </footer>
  </div>
</template>

<script>
export default {
  name: 'dash-footer',
  props: [ 'version' ]
}
</script>


// WEBPACK FOOTER //
// DashFooter.vue?1e8cae32